import { useLocation, useNavigate } from "react-router-dom";
import {
  RiDashboardLine,
  RiFileAddLine,
  RiListCheck2,
  RiUserLine,
  RiBuildingLine,
  RiArrowLeftSLine,
  RiArrowRightSLine,
} from "react-icons/ri";
import { MdOutlineAccountBalance } from "react-icons/md";
import { IoBriefcaseOutline } from "react-icons/io5";
import { TbReportAnalytics } from "react-icons/tb";
import useAuth from "../useAuth";
import { AnalyticsOutlined, ReportOutlined } from "@mui/icons-material";

export default function NavBar() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, menuOpen, changeMenuSize } = useAuth();

  const navItems = [
    {
      name: "Dashboard",
      icon: <RiDashboardLine className="text-lg" />,
      path: "home",
      description: "Overview & Analytics",

      disabled: false,
    },
    {
      name: "New Proposal",
      icon: <RiFileAddLine className="text-lg" />,
      path: "addNewScheme",
      description: "Create New Project",
      disabled: false,
    },
    {
      name: "Proposals List",
      icon: <RiListCheck2 className="text-lg" />,
      path: "schemesList",
      description: "All Projects",
      disabled: false,
    },

    // {
    //   name: "Draft Analysis",
    //   icon: <AnalyticsOutlined className="text-lg" />,
    //   path: "draftAnalysis",
    //   description: "Draft Analysis",
    //   disabled: false,
    // },

    {
      name: "Reports",
      icon: <TbReportAnalytics className="text-lg" />,
      path: "report",
      description: "Analytics & Insights",
      adminOnly: true,
      disabled: false,
    },

    // {
    //   name: "Financial",
    //   icon: <MdOutlineAccountBalance className="text-lg" />,
    //   path: "financial",
    //   description: "Budget & Payments",
    //   disabled: false,
    // },
    // {
    //   name: "Execution",
    //   icon: <IoBriefcaseOutline className="text-lg" />,
    //   path: "execution",
    //   description: "Project Execution",
    //   disabled: false,
    // },

    {
      name: "Profile",
      icon: <RiUserLine className="text-lg" />,
      path: "profile",
      description: "Account Settings",
      disabled: false,
    },
  ];

  return (
    <div
      className={`relative h-screen bg-white border-r border-slate-200 transition-all duration-300
      ${menuOpen ? "w-72" : "w-20"} flex flex-col shadow-sm`}
    >
      {/* Logo Section */}
      <div className="p-5 border-b border-slate-200 bg-white">
        <div className="flex items-center space-x-3">
          <div className="p-2.5 rounded-lg bg-blue-700 text-white shadow-sm">
            <RiBuildingLine className="text-lg" />
          </div>

          {menuOpen && (
            <div>
              <h1 className="text-blue-600 font-semibold text-base">
                Panchayati Raj
              </h1>
              <p className="text-slate-500 text-xs mt-0.5">Department</p>
            </div>
          )}
        </div>
      </div>

      {/* Navigation */}
      <div className="flex-1 overflow-y-auto no-scrollbar py-4">
        <div className="space-y-1 px-3">
          {navItems
            .filter((item) => {
              if (item.adminOnly) {
                return user?.userType?.toLowerCase() === "admin";
              }
              return true;
            })
            .map((item, index) => {
              const path = location.pathname.split("/")[2];
              const isActive = path === item.path;

              return (
                <button
                  key={index}
                  onClick={() => {

                    navigate(`/my/${item.path}`);
                  }}
                  className={`w-full text-left flex items-center transition-all duration-200 ${item?.disabled && "disabled:bg-gray-300 cursor-not-allowed"
                    }
                ${menuOpen ? "p-3 space-x-3" : "p-3 justify-center"}
                rounded-lg border
                ${isActive
                      ? "bg-blue-700 text-white border-blue-700"
                      : "bg-white text-slate-700 border-slate-200 hover:bg-slate-100"
                    }
                `}
                  disabled={item?.disabled}
                >
                  {item.icon}

                  {menuOpen && (
                    <div className="flex-1">
                      <span className="text-sm font-medium">{item.name}</span>
                      <p
                        className={`text-xs ${isActive ? "text-gray-100" : "text-slate-500"
                          }`}
                      >
                        {item.description}
                      </p>
                    </div>
                  )}

                  {/* Tooltip for collapsed */}
                  {!menuOpen && (
                    <div className="absolute left-full ml-2 px-3 py-1.5 rounded-md text-xs bg-white shadow border border-slate-200 opacity-0 group-hover:opacity-100 whitespace-nowrap">
                      {item.name}
                    </div>
                  )}
                </button>
              );
            })}
        </div>
      </div>

      {/* Collapse Button */}
      <div className="p-4 border-t border-slate-200 bg-white">
        <button
          onClick={changeMenuSize}
          className="w-full flex items-center justify-center p-2.5 bg-blue-700 text-white rounded-lg hover:bg-black transition"
        >
          {menuOpen ? (
            <RiArrowLeftSLine className="text-lg" />
          ) : (
            <RiArrowRightSLine className="text-lg" />
          )}
        </button>
      </div>
    </div>
  );
}
